import AppCommandBar from 'app/AppCommandBar'
import { FlexSpinner } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { PersonForm } from 'forms/PersonForm/PersonForm'
import { useShowCommand } from 'hooks/useCommand'
import { useFormikPanelState } from 'hooks/useFormikPanelState'
import useSelection from 'hooks/useSelection'
import { sortBy } from 'lodash-es'
import { UserRole } from 'model'
import { PanelType } from 'office-ui-fabric-react'
import { FormikPanel } from 'panels'
import * as React from 'react'
import { participantDetails } from 'views/ArchiveViews'
import { useReadProvingsPersonsViewQuery } from '../PersonsView.generated'
import { PersonsByDepartmentList } from './PersonsByDepartmentList'

const PersonsByDepartmentListView: React.FC = () => {
  const { loading, data, error } = useReadProvingsPersonsViewQuery()

  const [selection, selectedItems] = useSelection<any>({
    getKey: (item) => item!._id!,
  })
  const [participantPanelState, showParticipantPanel, ,] = useFormikPanelState()
  let participantsDetailsList: any[] = []
  const archivedProvings =
    data && data.provings ? data.provings.filter((x) => !x._deleted) : []

  archivedProvings.forEach((proving) => {
    if (proving.participants) {
      proving.participants.forEach((participant) => {
        if (participant.person) {
          participantsDetailsList.push({
            ...participant.person,
          })
        }
      })
    }
  })

  participantsDetailsList = sortBy(participantsDetailsList, 'firstName')

  const showParticipant = React.useCallback(
    (participant: participantDetails) => {
      const curParticipant = participant as any
      showParticipantPanel({
        ...curParticipant,
      })
    },
    [showParticipantPanel]
  )

  useShowCommand(
    { name: 'proving.participant', count: selectedItems.length },
    {
      priority: 20,
      onClick: () => {
        showParticipant(selectedItems[0])
      },
    },
    [selectedItems]
  )

  return (
    <FlexSpinner loading={loading} error={error}>
      <PersonsByDepartmentList
        items={participantsDetailsList}
        selection={selection}
        onItemInvoked={showParticipant}
      />
      <FormikPanel {...participantPanelState} type={PanelType.large}>
        <PersonForm items={archivedProvings} />
      </FormikPanel>
    </FlexSpinner>
  )
}

export const PersonsByDepartmentView: React.FC = () => (
  <>
    <ViewAuthorizer
      roles={[
        UserRole.SystemAdministrator,
        UserRole.ResourceManager,
        UserRole.Reader,
      ]}
    >
      <StickyPane>
        <AppCommandBar />
        <PersonsByDepartmentListView />
      </StickyPane>
    </ViewAuthorizer>
  </>
)
